import download from 'downloadjs'
import { getEkgQT, postEkgQTRequest, updateEkgQTStatus, postQTValues } from 'state/reducers/ekgRecordings/ekgRecordingActions'
import {
  getDataSource,
  getMe,
  getPatient,
  getPhysiciansAndEkgStackCount,
  getInterpretations,
  getEkgRecording,
  getEkgRecordingSamples,
  getEkgRecordingRelated,
  postInterpretEkgRecording,
  getSingleEkgPdf, openModal, closeModal,
  getVendorSpecificInterpretation,
  getPrescriptions,
} from '../../store/appReducer'
import { DATASOURCES, ECG_STACK_CONTROLS_ACTION_TYPE, CLEAR_STATE } from '../../constants'
import { handleOnNavClick as handleOnEkgRecordingNavClick } from '../../pages/EkgReviewEkgRecording/module'
import { checkMedantaAPIFeatureEnabled, checkIdtfServiceProviderFeatureEnabled, checkServiceProviderFeatureEnabled, checkServiceInterpretationFeatureEnabled } from 'configs'
import { postVendorSpecificInterpretationRecording } from '../ApiUrls'
import { getEkgReviewData } from '../../pages/QtEkgReview/module'
// ------------------------------------
// Constants
// ------------------------------------
const PREFIX = 'EkgRecordingReviewScreen.'
export const UPDATE_REFRESH_CLICKED = `${PREFIX}UPDATE_REFRESH_CLICKED`
export const UPDATE_ECG_EXPORTING = `${PREFIX}UPDATE_ECG_EXPORTING`
export const UPDATE_ADD_INTERPRETATION_SUBMITTING = `${PREFIX}UPDATE_ADD_INTERPRETATION_SUBMITTING`
export const UPDATE_SELECTED_DROPOVER = `${PREFIX}UPDATE_SELECTED_DROPOVER`
export const UPDATE_SELECTED_RECORDING_ID = `${PREFIX}UPDATE_SELECTED_RECORDING_ID`
export const UPDATE_INTERPRETATIONS = `${PREFIX}UPDATE_INTERPRETATIONS`
export const UPDATE_INTERPRETATION_NOTES = `${PREFIX}UPDATE_INTERPRETATION_NOTES`
export const SHOW_ADD_INTERPRETATION_SCREEN = `${PREFIX}SHOW_ADD_INTERPRETATION_SCREEN`
export const HIDE_ADD_INTERPRETATION_SCREEN = `${PREFIX}HIDE_ADD_INTERPRETATION_SCREEN`
export const TOGGLE_INTERPRETATION_HISTORY_EXPANDED = `${PREFIX}TOGGLE_INTERPRETATION_HISTORY_EXPANDED`
export const TOGGLE_RECORDING_INVERT = `${PREFIX}TOGGLE_RECORDING_INVERT`
export const DATA_REQUEST = `${PREFIX}DATA_REQUEST`
export const DATA_SUCCESS = `${PREFIX}DATA_SUCCESS`
export const DATA_FAILURE = `${PREFIX}DATA_FAILURE`
export const RESET_STATE = `${PREFIX}RESET_STATE`
//  medanta adhoc action
export const MEDANTA_INTERPRETATIONS = `${PREFIX}MEDANTA_INTERPRETATIONS`

// ------------------------------------
// Actions
// ------------------------------------
export const updateRefreshClicked = clicked => ({
  type: UPDATE_REFRESH_CLICKED,
  payload: clicked,
})
export const updateEcgExporting = flag => ({
  type: UPDATE_ECG_EXPORTING,
  payload: flag,
})
export const updateAddInterpretationSubmitting = flag => ({
  type: UPDATE_ADD_INTERPRETATION_SUBMITTING,
  payload: flag,
})
export const updateSelectedRecordingId = recordingId => ({
  type: UPDATE_SELECTED_RECORDING_ID,
  payload: recordingId,
})
export const updateSelectedDropover = dropover => ({
  type: UPDATE_SELECTED_DROPOVER,
  payload: dropover,
})
export const updateInterpretations = interpretations => ({
  type: UPDATE_INTERPRETATIONS,
  payload: interpretations,
})
export const updateInterpretationNotes = notes => ({
  type: UPDATE_INTERPRETATION_NOTES,
  payload: notes,
})
export const showAddInterpretationScreen = () => ({
  type: SHOW_ADD_INTERPRETATION_SCREEN,
})
export const hideAddInterpretationScreen = () => ({
  type: HIDE_ADD_INTERPRETATION_SCREEN,
})
export const toggleInterpretationHistoryExpanded = () => ({
  type: TOGGLE_INTERPRETATION_HISTORY_EXPANDED,
})
export const toggleRecordingInvert = () => ({
  type: TOGGLE_RECORDING_INVERT,
})
export const dataRequest = () => ({
  type: DATA_REQUEST,
})
export const dataSuccess = () => ({
  type: DATA_SUCCESS,
})
export const dataFailure = () => ({
  type: DATA_FAILURE,
})
export const resetState = () => ({
  type: RESET_STATE,
})

export const clearSelectedInterpretations = () => (dispatch, getState) => {
  dispatch(updateInterpretations([]))
}
export const clearInterpretationNotes = () => (dispatch, getState) => {
  dispatch(updateInterpretationNotes(''))
}

// medanta Interpretation
export const updateMedantaInterpretations = interpretation => ({
  type: MEDANTA_INTERPRETATIONS,
  payload: interpretation,
})

export const clearMedantaInterpretations = () => (dispatch, getState) => {
  dispatch(updateMedantaInterpretations({}))
}

export const handleOnPopoverButtonClick = dropover => (dispatch, getState) => {
  const {
    selectedDropover,
  } = getState().ekgRecordingReviewScreen

  if (dropover === selectedDropover) {
    dispatch(updateSelectedDropover(null))
  } else {
    dispatch(updateSelectedDropover(dropover))
  }
}

export const handleOnPopoverOutsideClick = () => (dispatch, getState) => {
  dispatch(updateSelectedDropover(null))
}

export const handleOnStackControlsCancelDialogClick = (dropover, callback) => (dispatch, getState) => {
  let promises = Promise.resolve()
  if (typeof callback === 'function') {
    promises = promises
      .then(() => callback(ECG_STACK_CONTROLS_ACTION_TYPE.CANCEL))
  }
  return promises
    .then(() => dispatch(updateSelectedDropover(null)))
}

export const handleOnStackControlsSuccessDialogClick = (dropover, callback) => (dispatch, getState) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME)
  const isServiceProviderEnabled = checkServiceProviderFeatureEnabled(meDataSource)
  let promises = Promise.resolve()
  if (typeof callback === 'function') {
    promises = promises
      .then(() => {
        // condition for checking the service provider enable
        if (isServiceProviderEnabled && callback.name === 'confirmAndArchiveCallback') {
          dispatch(handleQtFormSubmit(null, true))
        }
        callback(ECG_STACK_CONTROLS_ACTION_TYPE.OK)
      })
  }
  return promises
    .then(() => dispatch(updateSelectedDropover(null)))
}

export const clearSelectedRecordingId = () => (dispatch, getState) => {
  dispatch(updateSelectedRecordingId())
}

export const cancelAddInterpretations = () => (dispatch, getState) => {
  dispatch(clearSelectedInterpretations())
  dispatch(clearInterpretationNotes())
  dispatch(hideAddInterpretationScreen())
  dispatch(clearMedantaInterpretations())
}
export const saveAddInterpretations = () => (dispatch, getState) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME)
  const isMedantaAPIEnabled = checkMedantaAPIFeatureEnabled(meDataSource)
  // service provider boolean
  const isServiceProviderEnabled = checkServiceProviderFeatureEnabled(meDataSource)
  const isServiceInterpretationFeatureEnabled = checkServiceInterpretationFeatureEnabled(meDataSource)
  const qtFormData = getState().form && getState().form.qtValuesForm && getState().form.qtValuesForm.values ? getState().form.qtValuesForm.values : undefined

  // dispatch(dataRequest())
  const ekgsDataSource = getDataSource(getState(), DATASOURCES.EKGS)
  const {
    selectedRecordingId,
    selectedInterpretations,
    interpretationNotes,
    selectedMedantaInterpretations,
  } = getState().ekgRecordingReviewScreen
  const team_Id = meDataSource.data.teams[0].id
  const recording = ekgsDataSource.data.byId[selectedRecordingId]

  const postData = {
    interpretations: selectedInterpretations.map(int => int.key),
    inverted: recording.inverted,
    note: interpretationNotes,
    teamID: team_Id,
    recordingID: selectedRecordingId,
  }

  // by defaut case for the service provider and isServiceInterpretationFeatureEnabled if not selected any interpretation
  if (isServiceProviderEnabled && isServiceInterpretationFeatureEnabled && (selectedInterpretations.length === 0)) {
    // adding by default NOINTERPRETATION when no interpretation selected
    postData.interpretations = [ 'NOINTERPRETATION' ]
  }

  if (isMedantaAPIEnabled && Object.keys(selectedMedantaInterpretations).length !== 0) {
    // 'POST' to create new interpretation - 'PUT' to update existing interpretation
    let interpretationId = ''
    const vendorInterpretation = getDataSource(getState(), DATASOURCES.VENDOR_INTERPRETATION)
    let callMethod = 'POST'
    if (vendorInterpretation && vendorInterpretation.data && vendorInterpretation.data.interpretation) {
      callMethod = 'PUT'
      interpretationId = vendorInterpretation.data.id
    }

    const data = {
      teamId: team_Id,
      interpretation: JSON.stringify(selectedMedantaInterpretations),
    }

    dispatch(postVendorSpecificInterpretationRecording(postData, data, callMethod, interpretationId))
      .then(res => {
        console.log('Response', res)
      })
      // .then(() => dispatch(dataSuccess()))
      .catch(err => {
        console.log('VendorSpecificInterpretation', err)
      })
  }

  dispatch(updateAddInterpretationSubmitting(true))
  return dispatch(postInterpretEkgRecording(postData))
    .then(data => {
      dispatch(updateAddInterpretationSubmitting(false))
      dispatch(clearSelectedInterpretations())
      dispatch(clearInterpretationNotes())
      // if medanta is enabled and selectedMedantaInterpretations has interpretation,
      // already saved in db
      // get the latest added interpretation from DB
      if (isMedantaAPIEnabled && Object.keys(selectedMedantaInterpretations).length !== 0) {
        dispatch(getVendorSpecificInterpretation(selectedRecordingId, team_Id))
      }
      // if isServiceProviderEnabled, check qtFormData is available, call handleQtFormSubmit to submit QT data
      if (isServiceProviderEnabled) {
        if (qtFormData !== undefined) {
          // passing the interpretation id in qt submit
          dispatch(handleQtFormSubmit(data.payload.data.byId[selectedRecordingId].memberInterpretations[0].id))
        }
        // refresh data to get the updated team name and details
        dispatch(hideAddInterpretationScreen())
        dispatch(handleOnRefreshClick())
        if (postData && postData.interpretations && postData.interpretations.length && postData.interpretations[0] === 'NOINTERPRETATION') {
          dispatch(getEkgReviewData())
        }
      } else {
        dispatch(hideAddInterpretationScreen())
      }
    })
    .then(() => dispatch(dataSuccess()))
    .catch(err => {
      console.log('saveAddInterpretations', err)
      dispatch(updateAddInterpretationSubmitting(false))
      dispatch(clearSelectedInterpretations())
      dispatch(clearInterpretationNotes())
      dispatch(hideAddInterpretationScreen())
      dispatch(dataFailure())
    })
}

export const setInitialEkgRecordingReviewScreenData = recordingId => (dispatch, getState) => {
  dispatch(updateSelectedRecordingId(recordingId))
}

export const getEkgRecordingReviewScreenData = (forceUpdate = false) => (dispatch, getState) => {
  dispatch(dataRequest())
  const {
    selectedRecordingId,
  } = getState().ekgRecordingReviewScreen
  const meDataSource = getDataSource(getState(), DATASOURCES.ME)
  const interpretationsDataSource = getDataSource(getState(), DATASOURCES.INTERPRETATIONS)
  const isServiceProviderEnabled = checkServiceProviderFeatureEnabled(meDataSource)
  const isServiceInterpretationFeatureEnabled = checkServiceInterpretationFeatureEnabled(meDataSource)

  let promises

  if (meDataSource.data && !forceUpdate) {
    promises = Promise.resolve()
  } else {
    promises = dispatch(getMe())
  }

  if (interpretationsDataSource.data && !forceUpdate) {
    // no-op
  } else {
    promises = promises
      .then(() => {
        const me = getDataSource(getState(), DATASOURCES.ME)
        const {
          teams,
        } = me.data

        return dispatch(getInterpretations(teams[0].id))
      })
  }

  return promises
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME)
      const {
        teams,
      } = me.data
      const serviceProviderFeature =
        me.data.teams[0].features && me.data.teams[0].features.find(feat => feat.feature === 'qt-service-provider')
      const serviceProviderEnabled = serviceProviderFeature ? serviceProviderFeature.enabled : false
      const isMedantaAPIEnabled = checkMedantaAPIFeatureEnabled(meDataSource)
      const newPromises = [
        dispatch(getEkgRecordingSamples(selectedRecordingId)),
        dispatch(getEkgRecording(selectedRecordingId)),
        dispatch(
          getEkgQT(
            selectedRecordingId,
            isServiceProviderEnabled,
            isServiceInterpretationFeatureEnabled,
          ),
        ),
      ]
      if (!serviceProviderEnabled) {
        newPromises.push(dispatch(getEkgRecordingRelated(selectedRecordingId)))
      } // if medanta-api is enabled get the Vendor Specific Interpretation
      if (isMedantaAPIEnabled) {
        newPromises.push(dispatch(getVendorSpecificInterpretation(selectedRecordingId, teams[0].id)))
      }
      return Promise.all(newPromises)
    })
    .then(() => {
      const me = getDataSource(getState(), DATASOURCES.ME)
      const serviceProviderFeature =
        me.data.teams[0].features && me.data.teams[0].features.find(feat => feat.feature === 'qt-service-provider')
      const serviceProviderEnabled = serviceProviderFeature ? serviceProviderFeature.enabled : false
      const ekgs = getDataSource(getState(), DATASOURCES.EKGS)
      const physicians = getDataSource(getState(), DATASOURCES.PHYSICIANS)
      const ekgStackCounts = getDataSource(getState(), DATASOURCES.EKG_STACK_COUNTS)
      const patients = getDataSource(getState(), DATASOURCES.PATIENTS)
      const prescriptions = getDataSource(getState(), DATASOURCES.PRESCRIPTIONS)


      const {
        teams,
      } = me.data

      const recording = ekgs.data.byId[selectedRecordingId]
      const patientId = recording.participantID

      const apiCalls = []

      if (patientId && !serviceProviderEnabled && (!patients.data || (patients.data && !patients.data.byId[patientId]) || forceUpdate)) {
        apiCalls.push(dispatch(getPatient(patientId)))
      }

      if (!physicians.data || !ekgStackCounts.data || forceUpdate) {
        apiCalls.push(dispatch(getPhysiciansAndEkgStackCount(teams[0].id)))
      }

      return Promise.all(apiCalls)
    })
    .then(() => dispatch(dataSuccess()))
    .catch(err => {
      console.log('getEkgRecordingReviewScreenData', err)
      dispatch(dataFailure())
    })
}

export const handleQTModalOpen = () => dispatch => {
  dispatch(openModal())
}

export const handleQTModalClose = () => dispatch => {
  dispatch(closeModal())
}

export const handleOnRequestQT = () => (dispatch, getState) => {
  const {
    selectedRecordingId,
  } = getState().ekgRecordingReviewScreen
  dispatch(postEkgQTRequest(selectedRecordingId)).then(() => dispatch(getEkgRecordingReviewScreenData(true)))
    .catch(err => {
      console.log(err)
    })
  dispatch(closeModal())
}

export const handleOnExportClick = () => (dispatch, getState) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME)
  const isIDTFServiceProvider = checkIdtfServiceProviderFeatureEnabled(meDataSource)
  dispatch(dataRequest())

  let selectedRecordingId

  if (isIDTFServiceProvider) {
    selectedRecordingId = getState().annotator.recordingId
  } else {
    selectedRecordingId = getState().ekgRecordingReviewScreen.selectedRecordingId
  }

  dispatch(updateEcgExporting(true))
  return dispatch(getSingleEkgPdf(selectedRecordingId))
    .then(() => {
      const pdf = getDataSource(getState(), DATASOURCES.SINGLE_EKG_PDF)

      return download(pdf.data, `recording_${selectedRecordingId}.pdf`, 'application/pdf')
    })
    .then(downloaded => {
      dispatch(dataSuccess())
      dispatch(updateEcgExporting(false))
      return downloaded
    })
    .catch(err => {
      console.log('handleOnExportClick', err)
      dispatch(dataFailure())
    })
}


export const handleStackControl = func => (dispatch, getState) => {
  if (typeof func === 'function') {
    dispatch(dataRequest())
    return dispatch(func)
      .then(() => dispatch(dataSuccess))
      .catch(() => dispatch(dataFailure()))
  }
}

export const reset = () => (dispatch, getState) => {
  dispatch(resetState())
}

export const handleOnRefreshClick = () => (dispatch, getState) => {
  dispatch(updateRefreshClicked(true))
  return dispatch(getEkgRecordingReviewScreenData(true))
    .then(() => dispatch(updateRefreshClicked(false)))
}

export const handleOnStackNavigationClick = (direction = 0, currentInboxId = undefined, currentRecordingId = '', recordingIds = []) => (dispatch, getState) =>
  Promise.resolve()
    .then(() => {
      const currentRecordingIdIndex = recordingIds.indexOf(currentRecordingId)

      switch (direction) {
      case -1:
        if (currentRecordingIdIndex > 0) {
          return dispatch(handleOnEkgRecordingNavClick(true, {
            recordingId: recordingIds[currentRecordingIdIndex - 1],
            inboxId: currentInboxId,
            recordingIds,
          }))
        }
        break
      case 1:
        if (currentRecordingIdIndex < recordingIds.length - 1) {
          return dispatch(handleOnEkgRecordingNavClick(true, {
            recordingId: recordingIds[currentRecordingIdIndex + 1],
            inboxId: currentInboxId,
            recordingIds,
          }))
        }
        break
      default:
        break
      }
    })

export const handleQtFormSubmit = (interpretationID = null, qtConfirm = false) => (dispatch, getState) => {
  const meDataSource = getDataSource(getState(), DATASOURCES.ME)
  const isServiceProviderEnabled = checkServiceProviderFeatureEnabled(meDataSource)
  const isServiceInterpretationFeatureEnabled = checkServiceInterpretationFeatureEnabled(meDataSource)
  const teamId = meDataSource.data.teams[0].id
  const qtFormData = getState().form && getState().form.qtValuesForm && getState().form.qtValuesForm.values
  let formKeys
  let newForm = {}
  // newForm is blank when qtConfirm = true
  if ((typeof qtConfirm === 'function' && isServiceProviderEnabled) || !qtConfirm) {
    formKeys = qtFormData.qtVal && Object.keys(qtFormData.qtVal)
    newForm = JSON.parse(JSON.stringify(qtFormData))
    if (formKeys) {
      for (let i = 0; i < formKeys.length; i += 1) {
        newForm[formKeys[i]] = parseFloat(newForm.qtVal[formKeys[i]])
      }
    }
    if (newForm.errorType) {
      newForm.errorType = newForm.errorType.id
    }
    if (typeof interpretationID !== 'object' && interpretationID && interpretationID !== null) {
      newForm.interpretationId = interpretationID
    }
    delete newForm.qtVal
  }
  const {
    selectedRecordingId,
  } = getState().ekgRecordingReviewScreen

  dispatch(postQTValues(teamId,
    selectedRecordingId,
    newForm,
    isServiceProviderEnabled,
    isServiceInterpretationFeatureEnabled,
    qtConfirm))
    .then(() => {
      dispatch(
        getEkgQT(
          selectedRecordingId,
          isServiceProviderEnabled,
          isServiceInterpretationFeatureEnabled,
        ),
      )
      if (isServiceProviderEnabled) {
        dispatch(hideAddInterpretationScreen())
      }
    })
    .catch(err => {
      console.log(err)
    })
}



export const DROPOVER_TYPES = {
  STACK_CONTROL_CONFIRM_DIALOG: 'STACK_CONTROL_CONFIRM_DIALOG',
  STACK_CONTROL_REASSIGN_DIALOG: 'STACK_CONTROL_REASSIGN_DIALOG',
  STACK_CONTROL_REMOVE_DIALOG: 'STACK_CONTROL_REMOVE_DIALOG',
  COMPARE_TO_RELATED_RECORDING: 'COMPARE_TO_RELATED_RECORDING',
}

const initialState = {
  refreshClicked: false,
  ecgExporting: false,
  addInterpretationSubmitting: false,
  isInterpretationHistoryExpanded: false,
  isAddInterpretationScreenVisible: false,
  selectedRecordingId: '',
  selectedInterpretations: [],
  interpretationNotes: '',
  invertRecording: false,
  selectedDropover: null,
  dataIsFetching: false,
  dataLastUpdated: null,
  selectedMedantaInterpretations: {},
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_REFRESH_CLICKED]: (state, action) => ({
    ...state, refreshClicked: action.payload,
  }),
  [UPDATE_ECG_EXPORTING]: (state, action) => ({
    ...state, ecgExporting: action.payload,
  }),
  [UPDATE_ADD_INTERPRETATION_SUBMITTING]: (state, action) => ({
    ...state, addInterpretationSubmitting: action.payload,
  }),
  [UPDATE_SELECTED_DROPOVER]: (state, action) => ({
    ...state, selectedDropover: action.payload,
  }),
  [UPDATE_SELECTED_RECORDING_ID]: (state, action) => ({
    ...state, selectedRecordingId: action.payload,
  }),
  [UPDATE_INTERPRETATIONS]: (state, action) => ({
    ...state, selectedInterpretations: action.payload,
  }),
  [UPDATE_INTERPRETATION_NOTES]: (state, action) => ({
    ...state, interpretationNotes: action.payload,
  }),
  [SHOW_ADD_INTERPRETATION_SCREEN]: (state, action) => ({
    ...state, isAddInterpretationScreenVisible: true,
  }),
  [HIDE_ADD_INTERPRETATION_SCREEN]: (state, action) => ({
    ...state, isAddInterpretationScreenVisible: false,
  }),
  [TOGGLE_INTERPRETATION_HISTORY_EXPANDED]: (state, action) => ({
    ...state, isInterpretationHistoryExpanded: !state.isInterpretationHistoryExpanded,
  }),
  [TOGGLE_RECORDING_INVERT]: (state, action) => ({
    ...state, invertRecording: !state.invertRecording,
  }),
  [DATA_REQUEST]: (state, action) => ({
    ...state, dataIsFetching: true,
  }),
  [DATA_SUCCESS]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(),
  }),
  [DATA_FAILURE]: (state, action) => ({
    ...state, dataIsFetching: false, dataLastUpdated: new Date(),
  }),
  [RESET_STATE]: (state, action) => ({
    ...initialState,
  }),
  [CLEAR_STATE]: (state, action) => ({ ...initialState }),
  // medanta
  [MEDANTA_INTERPRETATIONS]: (state, action) => ({
    ...state, selectedMedantaInterpretations: action.payload,
  }),
}

// ------------------------------------
// Reducer
// ------------------------------------
export default function ekgRecordingReviewScreenReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/legacy/containers/EkgRecordingReviewScreen/module.js